import React, { createContext, useContext } from 'react';

import { IEntityDetails } from '../types';

interface IContextSwitcherDialogController {
  selectedEntity: IEntityDetails | null;
  showEntitySelectionDialog: boolean;
  showAppSelectionDialog: boolean;
  setSelectedEntity(entity: IEntityDetails | null): void;
  setShowEntitySelectionDialog(val: boolean): void;
  setShowAppSelectionDialog(val: boolean): void;
}

interface IContextSwitcherDialogControllerProps {
  children: React.ReactNode;
}

const ContextSwitcherDialogController = createContext<IContextSwitcherDialogController | undefined>(undefined);

export const ContextSwitcherDialogControllerProvider: React.FC<IContextSwitcherDialogControllerProps> = ({
  children
}) => {
  const [selectedEntity, setSelectedEntity] = React.useState<IEntityDetails | null>(null);
  const [showEntitySelectionDialog, setShowEntitySelectionDialog] = React.useState(false);
  const [showAppSelectionDialog, setShowAppSelectionDialog] = React.useState(false);

  const providerValue = React.useMemo(
    () => ({
      selectedEntity,
      setSelectedEntity,
      showEntitySelectionDialog,
      setShowEntitySelectionDialog,
      showAppSelectionDialog,
      setShowAppSelectionDialog
    }),
    [
      selectedEntity,
      setSelectedEntity,
      showEntitySelectionDialog,
      setShowEntitySelectionDialog,
      showAppSelectionDialog,
      setShowAppSelectionDialog
    ]
  );
  return (
    <ContextSwitcherDialogController.Provider value={providerValue}>
      {children}
    </ContextSwitcherDialogController.Provider>
  );
};

export const useContextSwitcherDialogController = () => {
  const context = useContext(ContextSwitcherDialogController);
  /* istanbul ignore next */
  if (!context) {
    throw new Error('useContextSwitcherDialogController must be used within a Provider');
  }
  return context;
};
